import * as React from "react";

import { FinancialYearForm } from "@impero-com/common/components/financialYear/editor";
import { NoAccessCard } from "@impero-com/common/components/noAccessCard/index";
import { isEqual } from "lodash-es";

import { useAvailableActions } from "../../utils/hooks/useAvailableActions";

import {
    financialYearToFormValues,
    useFinancialYearEditor,
} from "./useFinancialYearEditor";

export function FinancialYearOrgEditor() {
    const { financialYear, ...formProps } = useFinancialYearEditor();
    const availableActions = useAvailableActions();

    // This is a hack to reload the form after mutation because the data we
    // save is not necessarily the data we see in the form, it's equivalent but
    // different.
    const [
        lastSeenFinancialYearAndCounter,
        setLastSeenFinancialYearAndCounter,
    ] = React.useState({
        financialYear,
        // A react key is derived from this to forcibly unmount and remount the
        // form with new data.
        refreshCounter: 0,
    });

    if (
        !isEqual(financialYear, lastSeenFinancialYearAndCounter.financialYear)
    ) {
        setLastSeenFinancialYearAndCounter({
            financialYear,
            refreshCounter: lastSeenFinancialYearAndCounter.refreshCounter + 1,
        });
    }

    if (financialYear && availableActions.organization.financialYear.update) {
        return (
            <FinancialYearForm
                key={`financial-year-updater-${lastSeenFinancialYearAndCounter.refreshCounter}`}
                mode={{
                    type: "UPDATE",
                    initialValues: financialYearToFormValues(financialYear),
                }}
                {...formProps}
            />
        );
    } else if (
        !financialYear &&
        availableActions.organization.financialYear.create
    ) {
        return (
            <FinancialYearForm
                key={`financial-year-creator-${lastSeenFinancialYearAndCounter.refreshCounter}`}
                mode={{ type: "CREATE" }}
                {...formProps}
            />
        );
    } else {
        return <NoAccessCard />;
    }
}
